import(/* webpackMode: "eager" */ "/home/app/client/pb-front/src/app/[locale]/error.tsx");
